import React, {useEffect, useState} from "react";
import API from 'libs/api';
import {Button} from "semantic-ui-react";
import { useNavigate } from 'react-router-dom';
import {CHIPS, INPUT, TEXTAREA } from "components/cmp_form/cmp_form";
import ICON from 'components/cmp_icon/cmp_icon'
import CMP_CONFIRMATION from "components/cmp_confirmation/cmp_confirmation";
import PROCESSING from "components/cmp_processing/cmp_processing";

import './crd_details.css';



export default function CRD_DETAILS({ current_tab, activity_id, set_activity_name }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const navigate = useNavigate();

    const [var_details, set_details] = useState({});
    const [var_descriptions, set_descriptions] = useState({});
    const [var_detailsLoading, set_detailsLoading] = useState(false);
    const [var_descriptionsLoading, set_descriptionsLoading] = useState(false);
    const [var_detailsProcessing, set_detailsProcessing] = useState('inactive');
    const [var_descriptionsProcessing, set_descriptionsProcessing] = useState('inactive');



    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {
        get_details();
        get_descriptions();
    }, [activity_id]);



    //  async functions ------------------------------------------------------------------------------------------------

    async function get_details() {

        set_detailsLoading(true);
        set_detailsProcessing('processing');

        try {
            let results = await API_get_details();
            set_details(results);
            set_activity_name(results.name);
            set_detailsProcessing('inactive');
            set_detailsLoading(false);
        } catch (e) {
            set_detailsProcessing('error');
        }
    }

    async function get_descriptions() {

        set_descriptionsLoading(true);
        set_descriptionsProcessing('processing');

        try {
            let results = await API_get_descriptions();
            set_descriptions(results);
            set_descriptionsProcessing('inactive');
            set_descriptionsLoading(false);
        } catch (e) {
            set_descriptionsProcessing('error');
        }
    }

    async function put_details() {

        set_detailsLoading(true);
        set_detailsProcessing('processing');

        try {
            await API_put_details();
            await get_details();
        } catch (e) {
            set_detailsProcessing('error');
        }
    }

    async function put_descriptions() {

        set_descriptionsLoading(true);
        set_descriptionsProcessing('processing');

        try {
            await API_put_descriptions();
            await get_descriptions();
        } catch (e) {
            set_descriptionsProcessing('error');
        }
    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_get_details() {
        return API.get('admin-activities', '/get-details/' + activity_id);
    }

    function API_get_descriptions() {
        return API.get('admin-activities', '/get-descriptions/' + activity_id);
    }

    function API_put_details() {
        return API.put('admin-activities', '/put-details/', {body: var_details});
    }

    function API_put_descriptions() {
        return API.put('admin-activities', '/put-descriptions/', {body: var_descriptions});
    }



    //  event functions ------------------------------------------------------------------------------------------------

    function onChange_details(event) {
        let details = {...var_details};
        details[event.target.name] = event.target.value;
        set_details(details);
    }

    function onChange_descriptions(event) {
        let descriptions = {...var_descriptions};
        descriptions[event.target.name] = event.target.value;
        set_descriptions(descriptions);
    }

    function onClick_cancelDetails() {
        if (!var_detailsLoading) {
            get_details();
        }
    }

    function onClick_updateDetails() {
        if (!var_detailsLoading) {
            put_details();
        }
    }

    function onClick_cancelDescriptions() {
        if (!var_descriptionsLoading) {
            get_descriptions();
        }
    }

    function onClick_updateDescriptions() {
        if (!var_descriptionsLoading) {
            put_descriptions();
        }
    }



    // RENDER CONTAINER ================================================================================================

    return (

        <div id='activity--tab--details'>

            <div className='navigation__sidebar'>
                <div className='navigation__sidebar__item '>Basic information</div>
                <div className='navigation__sidebar__item '>Descriptions</div>
            </div>

            <div className='content__sidebar'>

                <div id='crd_provider_details' className='card '>
                    <div className='card__header'>
                        <div className='text--md bold'>Basic information</div>
                        <div className='text--sm color--gray--600'>Basic activity details and display options</div>
                    </div>
                    <div className='card__content'>

                        <INPUT
                            description='The activity name as it should appear in Lively Village'
                            errors={[]}
                            label='Name'
                            name='name'
                            onChange={onChange_details}
                            placeholder='Activity name'
                            value={var_details.keyword || null}
                        />

                        <INPUT
                            description="The activity unique identifier"
                            errors={[]}
                            label='Slug'
                            name='slug'
                            onChange={onChange_details}
                            placeholder='Slug'
                            value={var_details.slug || null}
                        />

                    </div>

                    <PROCESSING state={var_detailsProcessing}/>

                    <div className='card__footer'>
                        <Button className={'primary' + (var_detailsLoading ? ' inactive' : '')} onClick={onClick_updateDetails}>Update</Button>
                        <Button className={'secondary' + (var_detailsLoading ? ' inactive' : '')} onClick={onClick_cancelDetails}>Cancel</Button>
                    </div>
                </div>

                <div id='crd_provider_details' className='card '>
                    <div className='card__header'>
                        <div className='text--md bold'>Descriptions</div>
                        <div className='text--sm color--gray--600'>Activity on-page and meta SEO optimized descriptions</div>
                    </div>
                    <div className='card__content'>

                        <TEXTAREA
                            id='txt__description'
                            description='SEO optimized description that appears on the activity page'
                            errors={[]}
                            label='Description'
                            maxLength='2000'
                            name='description'
                            onChange={onChange_descriptions}
                            placeholder='Description'
                            value={var_descriptions.description || null}
                        />

                        <TEXTAREA
                            id='txt__description_meta'
                            description='The description that appears in search result pages'
                            errors={[]}
                            label='Meta description'
                            maxLength='200'
                            name='description_meta'
                            onChange={onChange_descriptions}
                            placeholder='Meta description'
                            value={var_descriptions.description_meta || null}
                        />

                        <TEXTAREA
                            id='txt__description_activity'
                            description='Description of the activity'
                            errors={[]}
                            label='Activity description'
                            maxLength='2000'
                            name='description_activity'
                            onChange={onChange_descriptions}
                            placeholder='Activity description'
                            value={var_descriptions.description_activity || null}
                        />

                        <TEXTAREA
                            id='txt__description_benefits'
                            description='Benefits of the activity'
                            errors={[]}
                            label='Activity benefits'
                            maxLength='2000'
                            name='description_benefits'
                            onChange={onChange_descriptions}
                            placeholder='Activity benefits'
                            value={var_descriptions.description_benefits || null}
                        />

                    </div>

                    <PROCESSING state={var_descriptionsProcessing}/>

                    <div className='card__footer'>
                        <Button className={'primary' + (var_descriptionsLoading ? ' inactive' : '')} onClick={onClick_updateDescriptions}>Update</Button>
                        <Button className={'secondary' + (var_descriptionsLoading ? ' inactive' : '')} onClick={onClick_cancelDescriptions}>Cancel</Button>
                    </div>

                </div>
            </div>
        </div>
    )
}